<template>
	<el-drawer class="update-task-status" title="任务状态更改" :visible.sync="dialog_visible" :wrapperClosable="false" size="600px" direction="rtl">
		<el-form ref="form" :model="form" label-width="80px" :rules="rules" style="padding: 0 20px;">
			<el-form-item label="任务状态" prop="taskStatus">
				<el-radio-group v-model="form.taskStatus" >
					<el-radio v-for="(item,index) in list" :key="index" :label="item.statusCode">{{item.statusName}}</el-radio>
				</el-radio-group>
			</el-form-item>
			<el-form-item label="修改备注" prop="taskRemarks">
				<el-input type="textarea" v-model="form.taskRemarks"></el-input>
			</el-form-item>
			<el-form-item style="float: right;">
				<el-button @click="dialog_visible = false">取消</el-button>
				<el-button type="primary" @click="onSubmit" :loading="loading">{{loading ? '提交中...' : '立即修改'}}</el-button>
				<el-button type="primary" @click="onClose">关闭此任务</el-button>
				
			</el-form-item>
		</el-form>
	</el-drawer>
</template>

<script>
	export default {
		data() {
			return {
				list:[],
				dialog_visible: false,
				form: {
					taskStatus: '',
					taskRemarks: ''
				},
				rules: {
					taskStatus:[{required:true,message:'请选择任务状态',trigger:'change'}],
					taskRemarks:[{required:true,message:'请填写修改备注',trigger:'blur'}]
				},
				taskIds:'',
				loading:false
			}
		},
		methods: {
			onClose(){
				this.$api.closeTaskBreathTaskInfo({
					taskIds:this.taskIds
				}).then(res => {
					if(res.errcode != 0) return;
					this.$notify.success('关闭成功');
					this.dialog_visible = false;
					this.$emit('getList')
				})
			},
			onSubmit() {
				this.$refs.form.validate((valid) => {
					if(valid){
						this.loading = true;
						this.$api.updateBreathTaskStatus({
							taskStatus: this.form.taskStatus,
							taskIds:this.taskIds,
							brandIdentify:this.$store.getters.userInfo.brandIdentify,
							taskRemarks: this.form.taskRemarks
						}).then(res => {
							this.loading = false;
							if(res.errcode != 0) return;
							this.$notify.success('状态更改成功');
							this.dialog_visible = false;
							this.$emit('getList')
						}).catch(()=>{
							this.loading = false;
						})
					}
				})
			},
			onShow(row){
				this.getTaskStatus()
				this.dialog_visible = true;
				this.$nextTick(() => {
					this.$refs.form.resetFields();
					let taskids = [];
					row.map(item => {
						taskids.push(item.taskId)
					})
					this.taskIds =taskids.join(',');
				})
				
			},
			getTaskStatus(){
				this.$api.getBreathTaskStatus({
					brandIdentify:this.$store.getters.userInfo.brandIdentify,
					statusState:'1'
				}).then(res => {
					if(res.errcode != 0) return;
					this.list = res.data.filter(el => el.statusCode > 1);
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.update-task-status {
		::v-deep {
			.el-radio-group {
				display: flex;
				flex-wrap: wrap;
				.el-radio {
					width: 100%;
					margin-top: 5px;
				}
			}
		}
	}
	
</style>
